import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import DisabilityModal from '../modal/DisabilityModal';
import DisabilityContent from './DisabilityContent';

const form = {
  keyword: '',
};

function DisabilityContainer({
  match,
  history,
  getDisabilityList,
  dataList,
  dataListPager,
  isLoading,
  removeDisability,
  showDisability,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DisabilityModal type="NEW" />,
      title: 'Add Disability',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DisabilityModal dataInfo={data.attributes} dataId={data.id} type="EDIT" />,
      title: 'Update Disability',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeDisability(data.id, () => {
          getDisabilityList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/social-ameliorations/settings/pwd/disability/${id}`);
            showDisability(id);
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getDisabilityList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    is_paginated: 1,
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getDisabilityList({ ...param, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:disabilityId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Type of Disability List"
            getData={getDisabilityList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:disabilityId?`}
            listName="Type of Disability"
            label="Type of Disability"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <p> {_.get(item, 'attributes.name')} </p>
              </div>
            )}
            isLoading={isLoading}
            selected={params.disabilityId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:disabilityId?`}
                    render={() => (
                      <DisabilityContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:disabilityId?`}
                  render={() =>
                    !params.disabilityId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

DisabilityContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getDisabilityList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  removeDisability: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showDisability: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_DISABILITIES}.list`) || [],
  dataListPager: _.get(api, `${c.GET_DISABILITIES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_DISABILITIES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DisabilityContainer);
